@if (finalization$ | async) {
  <ng-container [formGroup]="billOfLadingShipmentFinalizationForm">
    <div class="grid-row grid-gap-1">
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
        <label for="remarks" class="usa-label">Remarks</label>
        <input type="text" id="remarks" class="maxw-full usa-input" formControlName="additionalRemarks" value={{additionalRemarks}} />
      </div>
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
        <label for="authorityForCorrection" class="usa-label">Authority For Correction</label>
        <input type="text" id="authorityForCorrection" class="maxw-full usa-input" formControlName="authorityForCorrection" />
      </div>
    </div>
    <div class="grid-row grid-gap-1">
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
        <label for="correctionRemarks" class="usa-label">Additional Remarks For Correction Notice</label>
        <textarea type="text" id="correctionRemarks" rows="4" class="maxw-full usa-textarea" formControlName="correctionRemarks"></textarea>
      </div>
    </div>
  </ng-container>
}